module.exports = __webpack_public_path__ + "img/Application_1.e1b77c9d.png";